// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"d4d968a5","371":"708a4d37","420":"a6bac8b3","423":"a3e6f464","479":"bc4f6283","686":"0124af2b","690":"6aa3b591","860":"4289c0b6","947":"08109366"}[chunkId] + ".chunk.js";
};